import React from 'react';
import { useOffline } from '../context/OfflineContext';
import Icon from '../home/Icon';
import ReconnectButton from './ReconnectButton';
import './OfflineBanner.css';

// Offline-Hinweis im Main-Container jeder Seite. Sichtbar, solange die App im Offline-Modus ist (bis
// App-Neustart oder erfolgreichem "Erneut verbinden") — kein Hin-und-Her bei wackeliger Verbindung.
function OfflineBanner() {
  const { isOffline, reconnectFailed } = useOffline();
  if (!isOffline) return null;

  return (
    <div className="offlineBanner" role="status" aria-live="polite">
      <Icon className="offlineBannerIcon" icon="cloud_off" />
      <span className="offlineBannerText">
        {reconnectFailed
          ? <><strong>Weiterhin keine Verbindung</strong> – es werden weiter lokal gespeicherte Daten angezeigt.</>
          : <><strong>Offline-Modus</strong> – es werden lokal gespeicherte Daten angezeigt. Änderungen werden übertragen, sobald du wieder verbunden bist.</>}
      </span>
      <ReconnectButton />
    </div>
  );
}

export default OfflineBanner;
